import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline"

export const SaveCancelByIconButtons = ({
    onSaveClick,
    onCancelClick
}) => {
    return (
        <div className="relative">
            <div className="flex flex-row gap-1 absolute left-1/2 -translate-x-1/2 top-1">
                <button
                    onClick={() => onSaveClick()}
                    className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-green-500 hover:bg-green-700"
                >
                    <CheckIcon className="h-3 w-3" aria-hidden="true" />
                </button>
                <button
                    onClick={() => onCancelClick()}
                    className="inline-flex items-center p-1 border border-transparent rounded-full shadow-sm text-white bg-red-500 hover:bg-red-700"
                >
                    <XMarkIcon className="h-3 w-3" aria-hidden="true" />
                </button>
            </div>
        </div>
    )
}
